export default {
  controls: [
    {
      title: 'controls.folding_of_head_siderails',
      icon: 'icon-head-siderails-essenza200',
      animation: 'head_siderails',
      autoHideLabel: true,
      toggle: true
    },
    {
      title: 'controls.folding_of_middle_siderails',
      icon: 'icon-middle-siderails-essenza200',
      animation: 'middle_siderails',
      autoHideLabel: true,
      toggle: true
    },
    {
      title: 'controls.folding_of_protector_siderails',
      icon: 'icon-protector-siderails-essenza200',
      animation: 'protektor',
      autoHideLabel: true,
      toggle: true
    }
  ],
  solutions: [
    {
      title: 'solutions.ergonomics_and_mobilization',
      style: 'thumbnails',
      image: 'ergonomics_and_mobilization.jpg',
      explanation: 'ergonomics_and_mobilization'
    },
    {
      title: 'solutions.safety_and_comfort',
      style: 'thumbnails',
      image: 'safety_and_comfort.jpg',
      explanation: 'safety_and_comfort'
    },
    {
      title: 'solutions.effectiveness_and_wellbeing',
      style: 'thumbnails',
      image: 'effectiveness_and_wellbeing.jpg',
      explanation: 'effectiveness_and_wellbeing'
    }
  ],
  keyFeatures: [
    {
      title: 'key_features.ergonomics_and_mobilization',
      style: 'thumbnails',
      image: 'ergonomics_mobilization.jpg',
      explanation: 'ergonomics_mobilization',
    },
    {
      title: 'key_features.comfort',
      style: 'thumbnails',
      image: 'comfort.jpg',
      explanation: 'comfort',
    },
    {
      title: 'key_features.variety_of_controls',
      style: 'thumbnails',
      image: 'variety_of_controls.jpg',
      explanation: 'variety_of_controls',
    },
    {
      title: 'key_features.variety_of_siderails',
      style: 'thumbnails',
      image: 'variety_of_siderails.jpg',
      explanation: 'variety_of_siderails',
    }
  ],
  modifications: [
    {
      title: 'modifications.designink',
      icon: 'icon-colors',
      options: {
        style: 'vertical',
        default: 0,
        items: [
          {
            title: 'modifications.designink.none',
            image: 'no-texture.png',
            modelParts: [
              {
                name: 'zaklad_postele_done005',
                texture: null
              }
            ]
          },
          {
            title: 'modifications.texture.ess200_blue',
            image: 'blue.png',
            modelParts: [
              {
                name: 'zaklad_postele_done005',
                texture: 'postranice_blue.png'
              }
            ]
          },
          {
            title: 'modifications.texture.ess200_green',
            image: 'green.png',
            modelParts: [
              {
                name: 'zaklad_postele_done005',
                texture: 'postranice_green_stripe.png'
              }
            ]
          },
          {
            title: 'modifications.texture.ess200_gradient',
            image: 'gradient.png',
            modelParts: [
              {
                name: 'zaklad_postele_done005',
                texture: 'postranice_gradient.png'
              }
            ]
          },
          {
            title: 'modifications.texture.ess200_custom',
            image: 'custom.png',
            modelParts: [
              {
                name: 'zaklad_postele_done005',
                texture: 'postranice_custom.png'
              }
            ]
          }
        ]
      }
    },
    {
      title: 'modifications.mattress',
      icon: 'icon-mattress',
      options: {
        style: 'thumbnails',
        default: 0,
        items: [
          {
            title: 'modifications.mattress.with_mattress',
            image: 'with_matress.jpg',
            modelParts: [
              {
                name: 'matrace',
                visible: true
              }
            ]
          },
          {
            title: 'modifications.mattress.without_mattress',
            image: 'without_matress.jpg',
            modelParts: [
              {
                name: 'matrace',
                visible: false
              }
            ]
          }
        ]
      }
    },
    {
      title: 'modifications.accessories',
      icon: 'icon-accessories-essenza200',
      options: {
        style: 'thumbnails',
        default: 1,
        items: [
          {
            title: 'modifications.accessories.with_accessories',
            image: 'with_accessories.jpg',
            modelParts: [
              {
                name: 'hrazda',
                visible: true
              },
              {
                name: 'infuzni_stojan',
                visible: true
              },
              {
                name: 'prislusenstvi_protektor',
                visible: true
              }
            ]
          },
          {
            title: 'modifications.accessories.without_accessories',
            image: 'without_accessories.jpg',
            modelParts: [
              {
                name: 'hrazda',
                visible: false
              },
              {
                name: 'infuzni_stojan',
                visible: false
              },
              {
                name: 'prislusenstvi_protektor',
                visible: false
              }
            ]
          }
        ]
      }
    }
  ]
}